import { useMobileDetection } from './utils/deviceUtils';
import App from './App';
import MobileApp from './MobileApp';

function AppWrapper() {
  const isMobile = useMobileDetection();
  return isMobile ? <MobileApp /> : <App />;
}

export default AppWrapper;
